import {ReloadButton} from '@flexinet/ui-components';

import {Box} from '@mantine/core';

import {useQueryClient} from '@tanstack/react-query';

import {cardsKeys} from '../hooks/useCardsQuery';

/**
 * FNP-918: Reload invalidates the list key.
 *
 * ⚠️ It previously called `useCards().fetchRecords()`. Under the old `useQuery`
 * that re-ran the current page; under `useInfiniteQuery` `fetchRecords` means
 * FETCH THE NEXT PAGE — so the reload button would have appended page 2 instead
 * of refreshing what is on screen. Invalidating the key refetches every loaded
 * page and is what "reload" has always meant to the operator pressing it.
 *
 * Invalidating `cardsKeys.all` rather than one customer's list is deliberate:
 * the button does not know which customer is on screen and does not need to.
 */
export const ReloadRecordsButton = () => {

    const queryClient = useQueryClient();

    return (
        <Box mx='s'>
            <ReloadButton
                onClick={() => queryClient.invalidateQueries({
                    queryKey: cardsKeys.all,
                })}
            />
        </Box>
    );
};
